import { parse, isValid, format } from 'date-fns';

export function formatUTCDate(dateStr: string): string {
  console.log("DateStr from db: ", dateStr)
  // Create a UTC Date object from the ISO string
  const date = new Date(dateStr);
  // Extract UTC components
  const year = date.getUTCFullYear();
  console.log("Year is: ", year)
  const month = date.getUTCMonth();
  console.log("Month is: ", month)
  const day = date.getUTCDate();
  console.log("Day is: ", day)
  // Create a new date with UTC components
  const utcDate = new Date(year, month, day);

  console.log("Before Format: ", utcDate)
  console.log("After format: ", format(utcDate, 'MMM d, yyyy'))
  
  return format(utcDate, 'MMM d, yyyy');
}

export function parseAndValidateDate(dateStr: string): string | null {
  if (!dateStr) return null;
  
  // Try common date formats
  const formats = [
    'yyyy-MM-dd',
    'MM/dd/yyyy',
    'dd/MM/yyyy',
    'MM-dd-yyyy',
    'dd-MM-yyyy'
  ];

  for (const formatStr of formats) {
    const parsed = parse(dateStr, formatStr, new Date());
    if (isValid(parsed)) {
      return format(parsed, 'yyyy-MM-dd');
    }
  }

  return null;
}